<template>
  <div>
    <h1>testing</h1>
    <div class="row">
      <div class="col-6">
        <div
          class="col-12 margin-tb section-title dark-green-title"
          style="padding: 5px;"
        >
          <div class="text-center">
            <h3
              class="white-font row-table-font-margins"
              style="
                font-size: 20px;
                font-family: inherit;
                font-weight: 400;
                line-height: 1;
              "
            >
              COMMON EXPENSES
            </h3>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-condensed table-border">
            <thead
              class="thead-style text-center"
              v-bind:class="{ 'dark-green': dark }"
            >
              <tr>
                <th scope="col">Month</th>
                <th scope="col">Amount due</th>
                <th scope="col">Select all</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="month in months" :key="month.id">
                <td>{{ month.month }}</td>
                <td>{{ month.amount }}</td>
                <td><input type="checkbox" v-model="month.isSelected" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-6">
        <div
          class="col-12 margin-tb section-title dark-green-title"
          style="padding: 5px;"
        >
          <div class="text-center">
            <h3
              class="white-font row-table-font-margins"
              style="
                font-size: 20px;
                font-family: inherit;
                font-weight: 400;
                line-height: 1;
              "
            >
              ADDITIONAL EXPENSES
            </h3>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-condensed table-border">
            <thead class="thead-style" v-bind:class="{ 'dark-green': dark }">
              <tr>
                <th scope="col">Expense Type</th>
                <th scope="col">Amount due</th>
                <th scope="col">Select all</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="expense in expenses" :key="expense.id">
                <td>{{ expense.name }}</td>
                <td>{{ expense.amount }}</td>
                <td><input type="checkbox" v-model="expense.isSelected" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row">
        <div class="col-md-12 field">
          <div id="fields-holder-name"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 field">
          <div id="fields-card-number"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7 field">
          <div id="fields-expiration"></div>
        </div>
        <div class="col-md-5 field">
          <div id="fields-cvc"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Unused with Vue 3 (an SFC allows one script block; Vue 2 only used the last one):
[script]
SaferpayFields.init({
  // api key
  apiKey: "bd3086a2-0f00-4c68-bffc-29e3e9dc6289",
  // api url
  url: "https://test.saferpay.com/Fields/252078",
  style: {
    ".form-control":
      "border: none; border-bottom: solid 1px #ccc; border-radius: unset;",
  },
  paymentMethods: ["visa", "mastercard"],
  onSuccess: function () {
    //Callback on successful Init
  },
  onError: function (evt) {
    //Callback on unsuccessful Init
  },
  placeholders: {
    //Custom Text for Input placeholders
    holdername: "Card holder",
    cardnumber: "0000 0000 0000 0000",
    expiration: "MM/YY",
    cvc: "CVC",
  },
  onBlur: function (evt) {
    //Callback on blur (Card Holder leaves field)
  },
  onValidated: function (evt) {
    //Callback similar to on blur (Card Holder leaves field), but explicitly delivers validation data
  },
  onFocus: function (evt) {
    //Callback on focus (Card Holder clicks into field)
  },
});

// submit(); sends the entered hosted fields data to Saferpay.
SaferpayFields.submit({
  onSuccess: function (evt) {
    //Callback on successful Submit
  },
  onError: function (evt) {
    //Callback on unsuccessful Submit
  },
});
[/script]
-->
<!-- For Test-Environment-->
<!-- OR -->

<script>
export default {
  data() {
    return {
      months: [
        {
          id: 1,
          month: 1,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 2,
          month: 2,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 3,
          month: 3,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 4,
          month: 4,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 5,
          month: 5,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 6,
          month: 6,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 7,
          month: 7,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 8,
          month: 8,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 9,
          month: 9,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 10,
          month: 10,
          amount: 18.2,
          isSelected: true,
        },
        {
          id: 11,
          month: 12,
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 12,
          month: 12,
          amount: 18.2,
          isSelected: false,
        },
      ],
      expenses: [
        {
          id: 1,
          name: "Elevator",
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 2,
          name: "Garden",
          amount: 18.2,
          isSelected: false,
        },
        {
          id: 3,
          name: "Swimming Pool",
          amount: 18.2,
          isSelected: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
